const data = {
  underManagement: '1,000,000',
  underManagementSymbol: 'NXM',
  inReserve: '900,000',
  inReserveSymbol: 'wNXM',
}
export default data
